import en from './en';
import zh from './zh';
import kr from './kr';
import zhHK from "./zhHK";
import ja from "./ja";
import ru from './ru'
import fa from './fa'
import uk from './uk'
import vi from './vi'
import es from './es'
import fr from './fr'
export default {
  en: {...en},
  'zh-CN': {...zh},
  ko: {...kr},
  ja: {...ja},
  ru: {...ru},
  fa: {...fa},
  uk: {...uk},
  vi: {...vi},
  es: {...es},
  fr: {...fr},
  'zh-TC': {...zhHK},
  'zh-Hk': {...zhHK},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js